import { Module } from 'vuex';
import { IRootState } from '@/store';
import { ITimeOffState } from './timeoff.types';
import {
  ITimeOffPolicyData,
  ITimeOffTemplateData,
  ITimeOffTypeData
} from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: ITimeOffState = {
  version: 1,
  count: 0,
  timeOffPolicies: [] as ITimeOffPolicyData[],
  lastPromise: null,
  timeOffTypes: [] as ITimeOffTypeData[],
  templates: [] as ITimeOffTemplateData[]
};

const namespaced = true;

export const timeOff: Module<ITimeOffState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
